'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.prepareFullscreenItem = prepareFullscreenItem;
exports.prepareFullscreenItems = prepareFullscreenItems;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _proGalleryLayouter = require('pro-gallery-layouter');

var _galleryItem = require('@wix/pro-gallery-renderer/dist/src/components/item/galleryItem');

var _galleryItem2 = _interopRequireDefault(_galleryItem);

var _watermarkApi = require('@wix/photography-client-lib/dist/src/store/watermarkApi');

var _watermarkApi2 = _interopRequireDefault(_watermarkApi);

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertDtoToLayoutItem(dto) {
  var dtoMetadata = dto.metadata || dto.metaData;
  var metadata = _lodash2.default.isObject(dtoMetadata) ? dtoMetadata : _utils.utils.parseStringObject(dtoMetadata) || {};
  return (0, _extends3.default)({
    id: dto.itemId || dto.photoId,
    width: metadata.width,
    height: metadata.height
  }, dto);
}

function getItemScaleByContainerSize(item, _ref) {
  var width = _ref.width,
      height = _ref.height;

  var ratio = width / height;
  var cutByWidth = ratio > item.ratio;
  var scaleHeight = item.height / height;
  var scaleWidth = item.width / width;
  return cutByWidth ? scaleHeight : scaleWidth;
}

function prepareFullscreenItem(_ref2) {
  var item = _ref2.item,
      itemIdx = _ref2.itemIdx,
      windowSize = _ref2.windowSize,
      styleParams = _ref2.styleParams,
      _ref2$watermark = _ref2.watermark,
      watermark = _ref2$watermark === undefined ? _watermarkApi2.default.defaultWatermarkData : _ref2$watermark,
      scale = _ref2.scale,
      isExpandedView = _ref2.isExpandedView,
      isMobileZoom = _ref2.isMobileZoom;


  var window_width = windowSize.width;
  var window_height = windowSize.height;
  var window_ratio = window_width / window_height;

  // if (utils.isVerbose()) {
  // }
  // console.count('Preparing Fullscreen Item #' + itemIdx);

  var layoutItem = new _proGalleryLayouter.Item({
    idx: itemIdx,
    dto: convertDtoToLayoutItem(item.dto || item), //if the item is an GalleryItem object - use the dto
    cubeImages: false,
    watermark: watermark,
    createdBy: 'prepareFullscreenItems'
  });

  //calc the fullscreen sizes
  var overScale = _utils.utils.isTouch() && layoutItem.isImage ? 3 : 1; //bring overscaled images to make sure it remains sharp when pinching
  if (layoutItem.ratio > window_ratio || _utils.utils.isMobile() && _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout()) {
    layoutItem.resize(window_width / layoutItem.width * overScale);
  } else {
    layoutItem.resize(window_height / layoutItem.height * overScale);
  }

  layoutItem.width = Math.floor(layoutItem.width / overScale);
  layoutItem.height = Math.floor(layoutItem.height / overScale);

  var galleryItem = new _galleryItem2.default({
    dto: layoutItem.dto,
    scheme: layoutItem.scheme,
    watermark: watermark,
    sharpParams: _lodash2.default.get(styleParams, 'sharpParams')
  });

  var minScale = scale.min(galleryItem);
  if (!isMobileZoom) {
    galleryItem.height = Math.ceil(galleryItem.height * minScale);
    galleryItem.width = Math.ceil(galleryItem.width * minScale);
    if (!isExpandedView && galleryItem.maxHeight && galleryItem.maxWidth && galleryItem.maxHeight > 1 && galleryItem.maxWidth > 1) {
      galleryItem.height = Math.min(galleryItem.height, galleryItem.maxHeight);
      galleryItem.width = Math.min(galleryItem.width, galleryItem.maxWidth);
    }
    galleryItem.createUrls();
  }

  galleryItem.preload_img = galleryItem.thumbnail_url.img;

  return galleryItem;
}

function prepareFullscreenItems(_ref3) {
  var srcItems = _ref3.srcItems,
      windowSize = _ref3.windowSize,
      styleParams = _ref3.styleParams,
      _ref3$watermark = _ref3.watermark,
      watermark = _ref3$watermark === undefined ? _watermarkApi2.default.defaultWatermarkData : _ref3$watermark,
      galleryItems = _ref3.galleryItems;


  if (_utils.utils.isVerbose()) {
    console.count('Preparing fullscreen items');
    console.time('Prepare fullscreen items');
  }

  var items = [];
  var item = void 0;
  var pointer = 0;

  var window_width = windowSize.width;
  var window_height = windowSize.height;
  var window_ratio = window_width / window_height;

  while (item = srcItems[pointer]) {
    // console.count('Preparing Fullscreen Item #' + item.idx);
    item = new _proGalleryLayouter.Item({
      idx: item.idx,
      dto: convertDtoToLayoutItem(srcItems[pointer].dto || srcItems[pointer]), //if the item is an GalleryItem object - use the dto
      cubeImages: false,
      sharpParams: _lodash2.default.get(styleParams, 'sharpParams'),
      watermark: watermark,
      createdBy: 'prepareFullscreenItems'
    });

    //calc the fullscreen sizes
    var overScale = _utils.utils.isTouch() && item.isImage ? 3 : 1; //bring overscaled images to make sure it remains sharp when pinching
    if (item.ratio > window_ratio || _utils.utils.isMobile() && _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout()) {
      // todo -  if (isNewFullscreen) {...........
      item.resize(window_width / item.width * overScale);
    } else {
      item.resize(window_height / item.height * overScale);
    }

    item.width = Math.floor(item.width / overScale);
    item.height = Math.floor(item.height / overScale);

    item = new _galleryItem2.default({
      dto: item.dto,
      scheme: item.scheme,
      watermark: watermark,
      sharpParams: _lodash2.default.get(styleParams, 'sharpParams')
    });

    var galleryItem = galleryItems && galleryItems[item.photoId];
    var useGalleryItem = galleryItem && !galleryItem.cubeImages && !(_utils.utils.isMobile() && (galleryItem.resizeWidth > window_width || galleryItem.resizeHeight > window_height)); //on mobile, use the gallery image only if its smaller than the screen (must be a light image for smooth transitions

    item.preload_img = useGalleryItem ? galleryItem.resized_url.img : item.thumbnail_url.img;

    //populate the items array
    items.push(item);

    //advance the pointer
    pointer++;
  }

  if (_utils.utils.isDev()) {
    console.timeEnd('Prepare fullscreen items');
  }

  return items;
}